<template>
  <div>
    <div class="default-container">
      <label-title class="mb-2" title="Dados do Plano" icon=""></label-title>
      <div class="row mb-2">
        <div class="col-md-4 col-12">
          <div>
            <v-label label="Nome do Plano"></v-label><br>
            <span v-if="plano.app && plano.app.length" class="lbl-deal-title">
              {{ plano.app[0].nome_plano }}
            </span>
          </div>
          <div>
            <v-label label="Complementos"></v-label><br>
            <template v-for="(addon, index) in plano.addons" class="lbl-deal-title">
              <span class="my-2 d-block" v-if="plano.app && plano.app.length" :key="index">
                {{ addon.nome }}
              </span>
            </template>
          </div>
        </div>
        <!-- <div class="col-md-3 col-3" v-if="!planoVencido">
                    <v-label label="Tempo Restante"></v-label>
                    <span class="lbl-data">{{ plano.plano_atual.diasrestantes }} Dias</span>
                </div> -->
        <div class="col-md-3 col-3">
          <v-label label="Data de Validade"></v-label><br>
          <span v-if="plano.plano_atual" class="lbl-data">{{ plano.plano_atual.dttermino | formatData }}</span>
        </div>
      </div>
      <div class="row" v-if="fimPeriodoTeste">
        <div class="col-12">
          <alert type="info" title="Seu Período de Testes Acabou!"
            text="Ative agora seu plano para continuar a utilizar o Nota Brasil!"></alert>
        </div>
      </div>
      <div class="row" v-if="plano && plano.plano_atual && planoVencido">
        <div class="col-12">
          <alert type="warning" title="Efetue o Pagamento" text="Efetue o pagamento para continuar a utilizar!"></alert>
        </div>
      </div>
      <div class="row" v-if="administrador">
        <div class="col-12">
          <v-button :label="labelAssinar" :success="true" @click="handleAtivar"></v-button>
          <v-button v-if="!appNFe && !planoVencido && !istrial" label="Trocar Meu Plano" icon="fa-exchange"
            @click="handleTrocarPlano"></v-button>
          <v-button v-if="!appNFe && !planoVencido && !istrial" label="Adicionar Complementos" icon="fa-plus"
            @click="handleIncrementAddons"></v-button>
        </div>
      </div>

      <hr>

      <alert-asaas />

      <hr>
      <label-title class="mb-2 mt-3" title="Recursos Utilizados" icon=""></label-title>
      <div class="row">
        <!-- {{ plano.recursosUtilizados }} -->
        <div class="col-md-4 col-12">
          <div class="row col-12 align-items-center my-0" v-for="(recurso, index) in plano.recursosUtilizados"
            :key="index">
            <v-label :label="index"></v-label>
            <span class="lbl-deal-title ml-2" style="font-size:15px">{{ recurso }}</span>
          </div>
        </div>
      </div>

      <hr>

      <div v-if="planoVencido" class="mt-5 mb-5 row col justify-content-center">
        <iframe width="560" height="315" src="//www.youtube.com/embed/JSFoOrlI4yo" frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen
          style="max-width: 800px"></iframe>
      </div>
      <div v-if="!planoVencido" class="mt-5 mb-5 row col justify-content-center">
        <iframe width="560" height="315" src="//www.youtube.com/embed/D_PE2O16_aI" frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen
          style="max-width: 800px"></iframe>
      </div>

      <hr>

      <label-title v-if="administrador && plano.dadosFaturamento" class="mb-2 mt-3" title="Dados Para Nota Fiscal"
        icon=""></label-title>

      <div class="row" v-if="administrador && plano.dadosFaturamento">
        <form-field ref="cnpj" v-model="plano.dadosFaturamento.cnpj" type="cnpj" col="3" label="CNPJ" name="cnpj"
          :v-errors="errors" v-validate="{ required: true, cnpj: true }"></form-field>
        <div class="w-100"></div>
        <form-field ref="nome" v-model="plano.dadosFaturamento.nome" type="text" col="6" label="Nome" name="nome"
          :v-errors="errors" v-validate="{ required: true, max: 60 }"></form-field>
        <div class="w-100"></div>
        <form-field v-model="plano.dadosFaturamento.cep" type="cep" col="2" label="Cep" name="cep" :v-errors="errors"
          v-validate="{ required: true }" @update="updateCep"></form-field>
        <div class="w-100"></div>
        <form-field v-model="plano.dadosFaturamento.endereco" type="text" col="4" label="Endereço" name="endereco"
          :v-errors="errors" v-validate="{ required: true, max: 60 }"></form-field>
        <div class="w-100"></div>
        <form-field v-model="plano.dadosFaturamento.nr" type="text" col="2" label="Número" name="nr" :v-errors="errors"
          v-validate="{ required: true, max: 20 }"></form-field>
        <div class="w-100"></div>
        <form-field v-model="plano.dadosFaturamento.complemento" type="text" col="4" label="Complemento"
          name="complemento" :v-errors="errors" v-validate="{ max: 40 }"></form-field>
        <div class="w-100"></div>
        <form-field v-model="plano.dadosFaturamento.bairro" type="text" col="4" label="Bairro" name="bairro"
          :v-errors="errors" v-validate="{ required: true, max: 60 }"></form-field>
        <div class="w-100"></div>
        <form-field v-model="plano.dadosFaturamento.uf" type="select2" col="4" label="Estado" name="uf"
          :v-errors="errors" v-validate="{ required: true }" :select2="{ entity: 'estado', minlength: 0 }"></form-field>
        <div class="w-100"></div>
        <form-field v-model="plano.dadosFaturamento.codmun" type="select2" col="4" label="Cidade" name="codmun"
          :v-errors="errors" v-validate="{ required: true }"
          :select2="{ entity: 'mun/uf/' + plano.dadosFaturamento.uf, minlength: 2 }"></form-field>
        <div class="col-12">
          <v-button label="Salvar" :success="true" @click="handleSalvarDados"></v-button>
        </div>
      </div>

      <hr>

      <label-title class="mb-2 mt-3" title="Histórico de Pagamentos" icon=""></label-title>

      <div class="row" v-if="plano.historico && plano.historico.length == 0">
        <div class="col-md-12 col-12 text-center">
          <span class="lbl">Não há dados de pagamento</span>
        </div>
      </div>

      <div class="mainbox" v-for="(item, index) in plano.historico" :key="index">
        <div class="box">
          <div class="row">
            <div class="col-md-2 col-3 text-center">
              <v-label label="Data de Pagamento"></v-label>
              <span class="lbl w-100">{{ item.data | formatData }}</span>
            </div>
            <div class="col-md-2 col-3 text-center">
              <v-label label="Valor"></v-label>
              <span class="lbl w-100"><small>R$</small> {{ item.valor | formatValue(2) }}</span>
            </div>
            <div class="col-md-2 col-3 text-center">
              <v-label label="Status"></v-label>
              <span class="lbl w-100">{{ item.status }}</span>
            </div>
            <div class="col-md-3 col-6 text-center">
              <v-label label="Plano"></v-label>
              <span class="lbl w-100">{{ item.nome_plano }}</span>
            </div>
            <div class="col-md-3 col-6 text-center">
              <v-label label="Forma de Pagamento"></v-label>
              <span class="lbl w-100">{{ item.formapagamento }}</span>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

</template>

<script>

import { SysVars } from '../main'
import axios from 'axios'
import { apiORDSapp, apiORDS } from '../shared/api-functions'
import AlertAsaas from '../components/alert-asaas.vue'

export default {
  props: {

  },

  data() {
    return {
      errmessages: [],  //armazena as mensagens de validacao do servidor para mostrar em tela
      plano: {},
      params: null,
    }
  },

  computed: {
    appNFe() {
      return SysVars.appNFe
    },

    administrador: function () {
      return SysVars.usuarioAdministrador
    },

    usuarios: function () {
      if (this.qtUsuarios == 1)
        return this.qtUsuarios + ' Usuário'
      else
        return this.qtUsuarios + ' Usuários'
    },
    planoVencido: function () {
      if (!this.isTrial && this.plano.plano_atual)
        return this.plano.plano_atual.diasrestantes == 0
      else
        return true
    },

    istrial: function () {
      return this.$store.getters.getSessao.istrial == 'S'
    },

    fimPeriodoTeste: function () {
      return this.$store.getters.getSessao.isendtrial == 'S'
    },

    labelAssinar: function () {
      if (this.plano.plano_atual && this.plano.plano_atual.istrial)
        return 'Assinar e Ativar Minha Conta'
      else
        return 'Renovar'
    },

  },

  watch: {

  },

  methods: {
    handleIncrementAddons() {
      let params = {
        app: this.plano.app[0].app,
        planoAtual: this.plano.app[0].plano,
        complementos: this.plano.addons,
        dadosFaturamento: this.plano.dadosFaturamento,
        recorrencia: this.plano.app[0].tipo,
        diasRestantes: this.plano.plano_atual.diasrestantes
      }
      SysVars.planosParams = params

      this.$router.push('/planos/complementos')
    },
    closeForm() {
      this.$emit('closeform')
    },

    handleTrocarPlano() {
      let params = {
        trocaPlano: true,
        app: this.plano.app[0].app,
        planoAtual: this.plano.app[0].plano,
        valorCredito: this.plano.plano_atual.valor_saldo,
        complementos: this.plano.addons,
        dadosFaturamento: this.plano.dadosFaturamento,
        recorrencia: this.plano.app[0].tipo
      }
      SysVars.planosParams = params
      this.$router.push('/planos/erp')
    },

    handleAtivar() {
      let app = this.plano.plano_atual.controle_app;
      let tipo = 'MENSAL';
      if (this.plano.app.length > 0) {
        app = this.plano.app[0].app;
        tipo = this.plano.app[0].tipo;
      }
      let params = {
        app: app,
        complementos: this.plano.addons,
        trocaPlano: true,
        renovacao: false,
        complementos: this.plano.addons,
        dadosFaturamento: this.plano.dadosFaturamento,
        recorrencia: tipo,
        valorCredito: 0
      }

      if (!this.istrial)
        if (!this.fimPeriodoTeste && !this.planoVencido) {
          params.planoAtual = this.plano.app[0].plano
          params.renovacao = true
        }


      SysVars.planosParams = params

      if (app == 'NFE')
        this.$router.push('/planos/nfe') //app antigo NFE
      else
        this.$router.push('/planos/erp')
    },

    updateCep() {
      //CARREGA INFORMACOES DO CEP
      this.plano.dadosFaturamento.endereco = SysVars.endereco.logradouro
      this.plano.dadosFaturamento.bairro = SysVars.endereco.bairro
      this.plano.dadosFaturamento.codmun = SysVars.endereco.ibge
      this.plano.dadosFaturamento.uf = SysVars.endereco.uf
    },

    async loadData() {

      // apiORDS(this.$store.getters.urlOrds + 'sessao/meuplano').then((result) => {
      apiORDSapp(this, 'sessao/meuplano/', 'get', null)
        .then((result) => {
          if (result)
            this.plano = result
          else
            this.plano = { plano_atual: {}, historico: [] }

        })

      this.$nextTick(function () {
        jQuery('[data-toggle="tooltip"]').tooltip()
      })

    },

    handleSalvarDados() {
      this.$validator.validateAll().then(isValid => {
        if (!isValid) {
          this.$erpToastError('Por favor, corrija os campos em destaque para continuar')
        } else {
          this.apiPost()
        }
      })
    },

    async apiPost() {

      var sendData = {}
      sendData = this.plano.dadosFaturamento

      const data = await apiORDSapp(this, 'sessao/meuplano/dadosfaturamento/', 'post', sendData)
      if (data.errmessages) {
        this.errmessages = data.errmessages
        this.$erpToastError('Alguns erros precisam ser corrigidos.')
      } else {
        this.$erpToastUpdated()
        this.errmessages = {}
      }
    },

  },

  components: {
    AlertAsaas
  },

  beforeCreate() {

  },

  mounted() {
    this.$nextTick(function () {
      jQuery('[data-toggle="tooltip"]').tooltip()
    })
  },

  created() {
    this.crudText = this.$crudText(this.crud)

    this.loadData()

    this.$scrollTo(0)

  }

}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/forms/app-minha-conta-form.vue